__turbopack_context__.v({
  "detailWrapper": "SiPgPq_detailWrapper",
  "isIframe": "SiPgPq_isIframe",
  "overflow": "SiPgPq_overflow",
});
